import AdyenLocationDetails from './AdyenLocationDetails';

export default AdyenLocationDetails;